<template>
  <loading fullscrean="true"/>
</template>
<script>
  import Loading from "../../../components/Loading";
  export default {
    name: 'Zap',
    components: { Loading },

    methods: {
      getUserZap() {
        this.$http.get('zap/' + this.$route.params.hash)
          .then(response => {
            if (response.data && response.data.success) {
              const dados = response.data.dados;

              if (dados.site) {
                window.location.replace(dados.site);

              } else {
                window.location.replace('/' + dados.dominio_delivery);
              }

            } else {
              this.$router.push({ path: '/404', replace: true });
              this.load = false;
            }

          }, res => {
            this.load = false;
            this.$router.push({ path: '/404', replace: true });
            // this.$swal(res.data.msg);
          });
      },
    },

    mounted() {
      this.getUserZap();
    }
  }
</script>
